import * as React from "react";

const ReceivedIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size}
    height={props.size}
    {...props}
    viewBox="0 0 30 30"
  >
    <g data-name="Group 3229">
      <g fill="none" stroke="#1a80c0" data-name="Ellipse 1251">
        <circle cx={15} cy={15} r={15} stroke="none" />
        <circle cx={15} cy={15} r={14.5} />
      </g>
    </g>
    <path
      fill="#4dba41"
      d="M14.053 6.944v13.435l-3.4-3.394-1.341 1.336 5.689 5.689 5.689-5.689-1.337-1.337-3.4 3.394V6.944Z"
    />
  </svg>
);
export default ReceivedIcon;
